import type { ReactNode } from 'react';

export function Paragraph(props: { children: ReactNode; className?: string }) {
    return <p className={props.className || ''}>{props.children}</p>;
}
